<template>
    <v-card flat outlined>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="10" md="8">
                    <div>
                        <v-img :src="require('@/assets/videos/'+course.short+'.png')" contain></v-img>
                    </div>

                    <div class="display-1 font-weight-medium ml-2 mt-4" :style="{color:course.color}" v-html="course.title"></div>

                    <div class="pl-2 pb-4">
                        <div class="mt-1 subtitle-1 grey--text text--darken-3" style="line-height:1.4" v-html="course.invitation"></div>

                        <div class="mt-4" v-if="$vuetify.breakpoint.xsOnly">
                            <v-btn :color="course.color" class="white--text" depressed @click="$emit('watch')">Watch Videos</v-btn>
                        </div>

                        <v-divider class="mt-6"></v-divider>

                        <div class="title font-weight-regular mt-4 grey--text text--darken-3 d-flex align-center">
                            <v-icon :color="course.color" small class="mr-2">fa-check-circle</v-icon>
                            <div>Summary</div>
                        </div>
                        <div class="ml-5">
                            <div class="ml-2" v-html="course.summary"></div>
                        </div>

                        <div class="title font-weight-regular mt-4 grey--text text--darken-3 d-flex align-center">
                            <v-icon :color="course.color" small class="mr-2">fa-check-circle</v-icon>
                            <div>Objectives</div>
                        </div>
                        <div class="ml-5">
                            <div v-if="course.objectivesTitle" v-html="course.objectivesTitle"></div>
                            <ol>
                                <li v-for="item in course.objectives" :key="item">
                                    <div v-html="item"></div>
                                </li>
                            </ol>
                        </div>

                        <div class="title font-weight-regular mt-5 grey--text text--darken-3 d-flex align-center">
                            <v-icon :color="course.color" small class="mr-2">fa-check-circle</v-icon>
                            <div>Suggestions</div>
                        </div>
                        <div class="ml-5">
                            <div v-if="course.suggestionsTitle" v-html="course.suggestionsTitle"></div>
                            <ol>
                                <li v-for="item in course.suggestions" :key="item">
                                    <div v-html="item"></div>
                                </li>
                            </ol>
                        </div>

                        <div class="title font-weight-regular mt-5 grey--text text--darken-3 d-flex align-center">
                            <v-icon :color="course.color" small class="mr-2">fa-check-circle</v-icon>
                            <div>Lesson Summary Tips</div>
                        </div>
                        <div class="ml-5">
                            <div class="ml-2" v-if="course.tipsTitle" v-html="course.tipsTitle"></div>
                            <ol>
                                <li v-for="item in course.lessonTips" :key="item">
                                    <div v-html="item"></div>
                                </li>
                            </ol>
                        </div>

                        <div class="title font-weight-regular mt-5 grey--text text--darken-3 d-flex align-center">
                            <v-icon :color="course.color" small class="mr-2">fa-check-circle</v-icon>
                            <div>Conclusion</div>
                        </div>
                        <div class="ml-5">
                            <div class="ml-2" v-html="course.conclusion"></div>
                        </div>

                        <div class="title font-weight-regular mt-5 grey--text text--darken-3 d-flex align-center">
                            <v-icon :color="course.color" small class="mr-2">fa-check-circle</v-icon>
                            <div>Challenge</div>
                        </div>
                        <div class="ml-5">
                            <div class="ml-2" v-html="course.challenge"></div>
                        </div>

                        <v-btn :color="course.color" class="white--text mt-8" depressed @click="$emit('watch')">
                            <v-icon small left color="white">fa-video</v-icon>
                            Watch Videos now
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="12" sm="2" md="4">
                    <div class="text-center mt-6">
                        <v-btn :color="course.color" class="white--text" x-large depressed @click="$emit('watch')">Watch Videos</v-btn>
                    </div>
                </v-col>
            </v-row>
            
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        
    }),
    props: ['course']
}
</script>